module.exports = __webpack_public_path__ + "static/media/cancel.cfdbafe3.png";